import React, { useState } from 'react';
import { Alert } from './Alert';
import useFormStatus from '../Hooks/useFormStatus';
import EnterpriseConversionForm from './EnterpriseConversionForm';
import { fetchApiData, interpolate } from '../Utils/ApiCalls';
import { GET_ENTERPRISE_DETAILS } from '../urls';
import LoaderCircle from './LoaderCircle';
import { Button } from '@attentive-platform/stem-ui';
import { transformContractData } from '../Utils/HelperFunctions';
import { INITIAL_FORM_DATA } from '../Constants/Constants';

const UpdateContract = () => {
  const [email, setEmail] = useState('');
  const [showEnterpriseForm, setShowEnterpriseForm] = useState(false);
  const [showCategoryPricing, setShowCategoryPricing] = useState(false);

  // Enterprise data
  const [enterpriseAttributes, setEnterpriseAttributes] = useState();
  const [accountSegment, setAccountSegment] = useState(INITIAL_FORM_DATA.account_segment);
  const [companyVertical, setCompanyVertical] = useState(INITIAL_FORM_DATA.company_vertical);
  const [keyAccountManager, setKeyAccountManager] = useState(INITIAL_FORM_DATA.key_account_manager);
  const [onboardingSpecialist, setOnboardingSpecialist] = useState(INITIAL_FORM_DATA.onboarding_specialist);
  const [billingDetails, setBillingDetails] = useState();
  const [enterpriseContract, setEnterpriseContract] = useState();
  const [platformAccess, setPlatformAccess] = useState();
  const [loading, setLoading] = useState(false);
  const [enterpriseOptionalFeatures, setEnterpriseOptionalFeatures] = useState();
  const [totalUsers, setTotalUsers] = useState();
  const [isLicenseBillingEnabled, setIsLicenseBillingEnabled] = useState(false);

  const { successMessage, errorMessage, handleApiResult } = useFormStatus();

  const handleSubmit = async e => {
    e.preventDefault();
    setLoading(true);
    const encodedMail = encodeURIComponent(email.toLowerCase());
    const url = interpolate(GET_ENTERPRISE_DETAILS, [encodedMail]);
    const response = await fetchApiData({
      endpoint: url,
      apiRequest: 'GET'
    });

    const data = response?.data;

    handleApiResult(response);

    if (response.error === null) {
      setTotalUsers(data?.total_users);
      setAccountSegment(data?.account_segment || '');
      setCompanyVertical(data?.company_vertical || '');
      setKeyAccountManager(data?.key_account_manager);
      setOnboardingSpecialist(data?.onboarding_specialist);
      setEnterpriseAttributes(data?.enterprise_attributes);
      setEnterpriseContract(transformContractData(data?.enterprise_contract || {}, 'centsToDollar'));
      setBillingDetails(data?.billing_details || {});
      setPlatformAccess(data?.platform_access);
      setEnterpriseOptionalFeatures(data?.optional_feature_costs);
      setIsLicenseBillingEnabled(data?.is_license_billing_enabled ?? false);
      setShowEnterpriseForm(true);
      setShowCategoryPricing(true);
    }
    setLoading(false);
  };

  return (
    <div className='w-100'>
      <Alert errorMessage={errorMessage} successMessage={successMessage} />
      <form onSubmit={handleSubmit} className='w-100 mb-4'>
        <div className='input-group mb-3'>
          <input
            type='Email'
            value={email}
            onChange={e => setEmail(e.target.value)}
            required
            className='form-control form-control-lg'
            placeholder='Email'
            aria-label='Email'
          />
        </div>
        <div className='button'>
          <Button type='submit' color='primary'>
            Next
            {loading && <LoaderCircle />}
          </Button>
        </div>
      </form>
      {showEnterpriseForm && (
        <EnterpriseConversionForm
          enterpriseAttributes={enterpriseAttributes}
          accountSegment={accountSegment}
          companyVertical={companyVertical}
          keyAccountManager={keyAccountManager}
          onboardingSpecialist={onboardingSpecialist}
          billingDetails={billingDetails}
          enterpriseContract={enterpriseContract}
          platformAccess={platformAccess}
          email={email}
          enterpriseOptionalFeatures={enterpriseOptionalFeatures}
          totalUsers={totalUsers}
          isLicenseBillingEnabled={isLicenseBillingEnabled}
          updateEnterprise
          showCategoryPricing={showCategoryPricing}
          setEmail={setEmail}
        />
      )}
    </div>
  );
};

export default UpdateContract;
